export enum ExternalOrderStatusEnum{
    Created = "CREATED", // Заказ сформирован.
    InTransportService ="IN_TRANSPORT_SERVICE", // Отправлено в транспортную службу.
    TransferredToSubordinate = "TRANSFERRED_TO_SUBORDINATE", // Передано подведу.
    Rejected = "REJECTED", // Отказано.
    ReturnedIncomplete = "RETURNED_INCOMPLETE", // Возвращено не полностью.
    ReturnedComplete = "RETURNED_COMPLETE", // Возвращено полностью.
}
